import React from 'react'
import QrCode from "./Components/QrCode"
import "./style.css"
const App = () => {
  return( 
    <div className="section container">
      <QrCode />
    </div>
  )
}

export default App